<template>
  <v-container fluid>
    <router-view/>
  </v-container> 
</template>

<script>
export default {
  components:{

  },
  data() {
    return {
      
    }
  },
  methods:{
    
  }  
}
</script>

<style>

</style>
